import React, { useMemo } from "react";
import { useTheme } from "@material-ui/core";
import { RouteComponentProps } from "react-router-dom";

import App, {
  CruisesModuleProps as AppProps,
} from "../../../../../../cap1-modules/cruises-module/src/App";
import type { CoreCruisesCheckout } from "redmond";
import { useCruisesCheckoutProps } from "@capone/portal";

/**
 * Host wrapper that mounts the cruises-module checkout page under the core
 * cruises funnel — mirror of `LegacyActivitiesBooking.tsx`.
 *
 * Despite the "Legacy" prefix (the host's naming convention for wrappers that
 * mount a capone microfrontend under the new core funnel), this is the
 * REPLATFORMED path: it feeds the cruise book page a `core` payload from the
 * portal via `useCruisesCheckoutProps()`.
 */
interface ICruisesModuleProps extends RouteComponentProps {
  language: string;
  core?: CoreCruisesCheckout;
}

const CruisesModule = (props: ICruisesModuleProps) => {
  const { language, core, ...routerProps } = props;
  const { history } = routerProps;
  const theme = useTheme();

  const moduleProps: AppProps = useMemo(
    () => ({
      language,
      theme,
      baseHistory: history,
      core,
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [core],
  );

  return <App {...moduleProps} />;
};

export const LegacyCruisesBooking = (
  props: React.ComponentProps<typeof CruisesModule>,
) => {
  const checkoutProps = useCruisesCheckoutProps();
  return <CruisesModule {...props} core={checkoutProps} />;
};
